module.exports = __webpack_public_path__ + "img/1-14.6afb4acc.jpg";